<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800" v-if="isEdit">Editar Categoría</h1>
      <h1 class="h3 mb-2 text-gray-800" v-else>Crear Categoria</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">

        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <div class="row">
              <div class="col-6">
                  <b-form-group label="Título" label-for="keyInput" >
                    <b-form-input id="keyInput"  v-model="form.description" required ></b-form-input>
                  </b-form-group>
              </div>
            </div>
            <b-button type="submit" variant="primary">Guardar</b-button>
          </b-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";

export default {
  data() {
    return {

      form: {
        description: '',
      },
      show: true,
      categoryId: null,
      isEdit: false,
      titulo: '',
      lecciones: [{ nombre: '' }],
    }
  },
  methods: {
    onSubmit(event) {
      event.preventDefault()
      let loader = this.$loading.show({});
      if (this.isEdit) {
        axios.put(import.meta.env.VITE_API_BASE_URL + "/api/categories/edit/" + this.categoryId , this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Categoría Editada."
          );
          console.log(result);
          loader.hide();
          router.push({ path: `/admin-panel/categorias` })
        }).catch((err) => {
          if (err.response.data.response === 'duplicated') {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Ya se ha creado una categoría con este nombre"
            );
            console.log(err.message);
            loader.hide();
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Error al editar"
            );
            console.log(err.message);
            loader.hide();
          }
        });
      } else {
        axios.post(import.meta.env.VITE_API_BASE_URL + "/api/categories/save", this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.s(
            "Categoría Guardada."
          );
          console.log(result);
          loader.hide();
          router.push({ path: `/admin-panel/categorias` })
        }).catch((err) => {
          if (err.response.data.response === 'duplicated') {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Ya se ha creado una categoría con este nombre"
            );
            console.log(err.message);
            loader.hide();
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
             "Error al crear"
            );
            console.log(err.message);
            loader.hide();
          }
        });
      }
    },
    onReset(event) {
      event.preventDefault()
    },
  },
  mounted() {
    if (this.$route.params.id) {
      let loader = this.$loading.show({});
      this.categoryId = this.$route.params.id;
      this.isEdit = true;
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/categories/getById/" + this.categoryId,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.form.description = response.data.description;
          this.form.lessons = response.data.lessons;
          if(response.data === '') {
            console.log(response.data)
            this.lessonsModule = [];
            this.simulacrumsModule = [];
            return;
          }
          let data= response.data;

          /*data.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
          });*/

          this.lessonsModule = data;
          this.simulacrumsModule = data;
          loader.hide();
        }).catch((err) => {
          console.log(err.message);
          loader.hide();
      });
    }
  },
  beforeMount() {

  },
}
</script>
